"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepperWithContent = void 0;
var _mui = require("@ori-ui/mui");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _swr = require("swr");
var _contexts = require("../../contexts");
var _api = require("../../models/api");
var _Stepper = require("../Stepper");
var _Steps = require("../Steps");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));
const ContentContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  maxWidth: '500px'
}));
const StepperWithContent = props => {
  const {
    currentStep,
    steps
  } = props;
  const {
    stepperData
  } = (0, _contexts.useStepperData)();
  const {
    activeStep,
    setActiveStep,
    setStepsOrder
  } = stepperData;
  const {
    registrationType
  } = (0, _contexts.useConfiguration)();
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const {
    cache
  } = (0, _swr.useSWRConfig)();
  const pbs_owner = _jsCookie.default.get('pbs_owner');
  const ecref = _jsCookie.default.get('ecref');
  const isVipCustomerType = registrationType === 'VipCustomer';
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we want logical operator
  const isCorrectReferral = pbs_owner || ecref;
  const vipWithoutSponsor = isVipCustomerType && !isCorrectReferral && !registrationData?.invitationCode;
  (0, _react.useEffect)(() => {
    setStepsOrder(steps);
  }, [setStepsOrder, steps]);
  (0, _react.useEffect)(() => {
    if (currentStep) {
      const actualStep = steps.indexOf(currentStep);
      if (actualStep !== -1) {
        setActiveStep(actualStep);
        cache.delete('registrationData');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed other property
  }, [currentStep]);
  const getStepperContent = () => {
    let content;
    switch (activeStep) {
      case 0:
        content = /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentContainer, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Steps.PersonalStep, {})
        });
        break;
      case 1:
        content = /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentContainer, {
          children: vipWithoutSponsor ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Steps.LegalStep, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Steps.SponsorStep, {})
        });
        break;
      case 2:
        content = /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentContainer, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Steps.LegalStep, {})
        });
        break;
      default:
        content = null;
    }
    return content;
  };
  const stepperContent = getStepperContent();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Stepper.Stepper, {
      canChangeStep: false,
      steps: steps,
      visibleLables: false
    }), stepperContent]
  });
};
exports.StepperWithContent = StepperWithContent;